const storeFormatIcons = [
  "faCircleMinus",
  "faStore",
  "faDesktop",
  "faUtensils",
  "faWarehouse",
  "faShop",
  "faFish",
  "faBreadSlice",
  "faWheatAlt",
  "faHospital",
  "faJugDetergent",
  "faHammer",
  "faBuildings",
];

const nonServiceable = {
  title: "Paumanhin po,\nngunit para sa may\nnegosyo lang ang\nGrowSari",
  subTitle: "Salamat sa inyong interes!",
  note: "Manatiling updated sa GrowSari!",
};

const nonServiceableDelivery = {
  title: "Sorry, hindi pa kami makakapag deliver sa inyong lugar",
  subTitle:
    "Huwag mag-alala, papalawakin pa namin ang sakop ng GrowSari. Makakatanggap kayo ng update kapag available na kami sa inyong lugar. Salamat!",
  note: "Manatiling updated sa GrowSari!",
};

const RETAIL_TYPE_ONLINE = "online";

export { storeFormatIcons, nonServiceable, nonServiceableDelivery, RETAIL_TYPE_ONLINE };
